/**
 * acknowledgment-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { MessageTag } from "../message-tag";
import { IncomingMessage, ValidatingClass } from "./incoming-message";
import { Message, OkMessage } from "./message";
import { ResponseCode } from "./response-code";

/**
 * An {@link AcknowledgmentResponse} represents generic resolution of a
 * client request.
 */
@validateFor(MessageTag.RSP_ACKNOWLEDGEMENT)
export class AcknowledgmentResponse extends IncomingMessage implements OkMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.RSP_ACKNOWLEDGEMENT;

    @validateAs("boolean")
    public ok : boolean;

    @validateAs("string", true, null)
    public reason : string;

    @validateAs(["integer", {min: 0}, {max: 10}], true, null)
    public code : ResponseCode | null;

    public static isOk (reply : Message) : boolean
    {
        return Message.isA(reply, MessageTag.RSP_ACKNOWLEDGEMENT)
            && (reply as AcknowledgmentResponse).ok;
    }

    public static elevateErrors (reply : AcknowledgmentResponse) : Message
    {
        if (!reply.ok)
        {
            console.error(reply);
            const msg : string = reply.reason || "Reply not OK: unknown reason";
            throw new Error(msg);
        }
        return reply;
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/acknowledgment-response.ts